import type { LucideIcon } from 'lucide-react';
import { Ban, CircleCheck, CircleX, Clock3 } from 'lucide-react';
import type { WriteOffStatus } from '@eombor/contracts';
import { cn } from '@eombor/ui';
import { t } from '../../../shared/i18n/index.js';

/**
 * Aktning HOLATI — rangi ma'noga bog'langan, lekin faqat rangga TAYANMAYDI:
 * har holatning o'z belgisi va nomi bor.
 *
 * `PENDING` neytral emas, `warn`: u kimningdir e'tiborini kutayotgan
 * yagona holat va navbatda ko'zga tashlanishi kerak.
 *
 * `REJECTED` va `CANCELLED` bitta «Rad etilgan» tabida turadi, shuning
 * uchun ular bir xil ko'rinmasligi SHART: rad etilgani — to'liq qizil
 * (buxgalter qaytargan, xodim tuzatishi mumkin), bekor qilingani esa
 * kulrang-qizil (xodim o'zi qaytarib olgan, yakuniy).
 *
 * Umumiy `Badge` ishlatilmaydi: unda bu oraliq tus yo'q va `cn`
 * tailwind-merge emas — `className` bilan ustidan yozish ishonchsiz.
 * Shakli esa `Badge` bilan bir xil.
 */
const STYLE: Record<WriteOffStatus, { icon: LucideIcon; className: string }> = {
  PENDING: { icon: Clock3, className: 'bg-warn-soft text-warn border-warn/30' },
  APPROVED: { icon: CircleCheck, className: 'bg-success-soft text-success border-success/30' },
  REJECTED: { icon: CircleX, className: 'bg-danger-soft text-danger border-danger/30' },
  CANCELLED: {
    icon: Ban,
    className: cn(
      'bg-[color-mix(in_oklab,var(--color-danger)_6%,var(--color-surface-2))]',
      'text-[color-mix(in_oklab,var(--color-danger)_40%,var(--color-text-muted))]',
      'border-[color-mix(in_oklab,var(--color-danger)_22%,var(--color-border))]',
    ),
  },
};

export const WriteOffStatusBadge = ({
  status,
  className,
}: {
  status: WriteOffStatus;
  className?: string;
}) => {
  const { icon: Icon, className: tone } = STYLE[status];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-[var(--radius-pill)] border',
        'px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        tone,
        className,
      )}
    >
      <Icon size={12} strokeWidth={2.25} aria-hidden />
      {t(`writeOff.status.${status}`)}
    </span>
  );
};
